import { Division } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

// 料率調整案件の一覧表のラベル
export const LABELS = {
  TITLE_REGIST: "加盟店登録",
  TITLE_EDIT: "加盟店編集",
  TITLE_TABLE: "調整内容",

  LAST_UPDATED_DATE: "最終更新日",
  LAST_UPDATED_BY: "最終更新者",

  MERCHANT_NAME: "加盟店名",
  SERVICE_NAME: "サービス名",
  ADD_ADJUSTMENT_DETAILS: "調整内容追加",

  BRANCH: "No",
  CONTRACT_ROUTE_NAME: "契約形態",
  GENERAL_COMPANY_NAME: "包括加盟店",
  SETTLEMENT_GW_COMPANY_NAME: "GW事業者",
  APPLICATION_DATE: "申請日",
  RESPONSE_DATE: "回答日",
  RESPONSE_RATE: "回答料率",
  DESIRED_RATE: "希望料率",
  SALES: "売上高（億円）",
  ALL_SHOP_NUMBER: "総店舗数",
  INSTALLED_SHOP_NUMBER: "導入店舗数",
  DOCOMO_INDUSTRY: "ドコモ定義業態",
  APPLICATION_INDUSTRY: "申請業態",
  HANDLING_PRODUCTS: "取扱商材",
  RATE_PRESENTATION_CRITERIA: "料率提示条件",
  COST_BURDEN: "費用負担",
  COST_BURDEN_ADJUSTMENT_INFORMATION: "費用負担調整情報",
  NOTE: "備考",
} as const;

export const PULLDOWN_LABELS_SP = {
  SERVICE_NAME_SHORT: "サービス名",
  REQUIRED_LONG: "必須　　　　　　　　　",
};

// SELECTの空行の定義
export const SELECT_BLANK = { label: "　　　　　　", value: "" };

// 区分取得結果変換
export const getDivisionItems = (
  divisions: Division[] | undefined
): DivisionDict[] => {
  if (divisions !== undefined) {
    return divisions.map((division) => ({
      label: division.label,
      value: division.kbnCode,
    }));
  }
  return [];
};
